import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";


@Component({
  selector: "app-modal-html-preview",
  templateUrl: "./modal-html-preview.component.html",
  styleUrls: ["./modal-html-preview.component.scss"],
})
export class ModalHtmlPreviewComponent implements OnInit, OnDestroy {
  iframeSrc!: SafeResourceUrl;
  private objectUrl: string;

  constructor(
    public dialogRef: MatDialogRef<ModalHtmlPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { html: string },
    private sanitizer: DomSanitizer
  ) {
    const blob = new Blob([data.html], { type: 'text/html' });
    this.objectUrl = URL.createObjectURL(blob);
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
  }

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }
}
